import React, { Fragment, Suspense } from 'react';
import { Redirect } from 'react-router-dom';
import ErrorPage from '../../containers/ErrorPage';
import { GENERIC_COMPONENT_MAP, GENERIC_TYPES_TO_WRAP } from './constants';
import { getBackground, getGivenBackground, startsReversed } from 'Utils/getColor';

/*
 * MAZDAHWS-1629: Code was copy & pasted from GenericContainer/index.js.
 * See GenericContainer/index.js for Git-History / Blame!
 * #wasntme ;)
 * */
export default class EkiContentRenderer extends React.Component {

  scrolled: false;
  yOffset = 0;
  scrollAttempt = 0;
  deeplinkTargetSearchTime  = 0;

  constructor(props) {
    super(props);
  }

  findDeeplinkTarget(deeplinkid) {
    setTimeout(() => {
      const scrollTarget = document.getElementById(deeplinkid);

      if (scrollTarget) {
        this.scrollToDeeplinkTarget(deeplinkid);
        return;
      }

      if (this.deeplinkTargetSearchTime >= 3000) {
        return;
      }

      this.deeplinkTargetSearchTime += 200;
      this.findDeeplinkTarget(deeplinkid);
    }, 200);
  }

  componentDidMount() {
    const deeplinkid =
      this.props.urlParams && this.props.urlParams.deeplinkid
        ? this.props.urlParams.deeplinkid
        : undefined;

    this.findDeeplinkTarget(deeplinkid);
  }

  scrollToDeeplinkTarget(deeplinkid) {
    const scrollTarget = document.getElementById(deeplinkid);

    this.yOffset = window.pageYOffset;

    if (scrollTarget) {
      this.scroll(scrollTarget.getBoundingClientRect().top);
    }
  }

  scroll(scrollTargetOffset) {
    if (this.props.preventScrollToDeeplikId) {
      return;
    }

    const { scrollAttempt, scrolled } = this

    if (!scrollTargetOffset || scrolled || scrollAttempt > 20) {
      return;
    }

    this.props.scrollToDeeplinkId(true);
    this.scrollAttempt += 1;

    if (window.pageYOffset > 0) {
      this.scrolled = true;

      return;
    }

    const scrollTimer = setTimeout(() => {
      if (scrolled) {
        return;
      }

      this.scroll(scrollTargetOffset);
      clearTimeout(scrollTimer);
    }, 300);
  }

  prepareContent(content, dealerId) {
    const elementsToWrap = Object.keys(GENERIC_TYPES_TO_WRAP);

    const result = [];
    let hasForm = null;

    for (let i = 0; i < content.length; i++) {
      if (
        (dealerId === '11292' || dealerId === '15664') &&
        (content[i].id === 219 || content[i].id === 220 || content[i].id === 222)
      )
        continue;

      if (
        elementsToWrap.indexOf(content[i].type) >= 0 &&
        content[i + 1] &&
        elementsToWrap.indexOf(content[i + 1].type) >= 0 &&
        elementsToWrap.indexOf(content[i].type) === elementsToWrap.indexOf(content[i + 1].type)
      ) {
        const currentType = content[i].type;
        const items = [content[i]];
        let j = i;
        while (content[j + 1] && currentType === content[j + 1].type) {
          items.push(content[j + 1]);
          j++;
        }
        const elementName = GENERIC_TYPES_TO_WRAP[content[i + 1].type];
        result.push({
          id: `${elementName}_${i}`,
          type: elementName,
          items,
        });
        i = j;
      } else {
        if (content[i].type === 'mask_form') {
          hasForm = content[i].formType;
        }

        result.push(content[i]);
      }
    }

    return [result, hasForm];
  }

  renderContentElement(contentElm, index, hasForm) {
    const {
      mainStore,
      pageId,
      dealer,
      history,
      onOpenContact,
      entry,
      sharedState,
      setSharedState,
      hasForm: hasFormAbove,
    } = this.props;
    const Component = GENERIC_COMPONENT_MAP[contentElm.type];
    const isNoLP = !entry.dokType || !entry.dokType.startsWith('landingpage');

    const offerList = contentElm.offerList
      ? contentElm.offerList.filter(
          (offer) =>
            !!offer &&
            !offer.hidden &&
            (!!offer.cashPrice ||
              !!offer.leasingPrice ||
              !!offer.financePrice ||
              offer.price !== 'undefined')
        )
      : undefined;

    if (Component) {
      return (<Suspense fallback={<div></div>}>
          <Component
            key={`${contentElm.id}-${index}`}
            hasForm={isNoLP ? undefined : hasForm || hasFormAbove}
            deeplinkId={contentElm.deeplinkId || `content-element-${index}`}
            consumptionText={contentElm.consumptionText}
            {...{
              pageId,
              dealer,
              history,
              mainStore,
              onOpenContact,
              entry,
              sharedState,
              setSharedState,
            }}
            {...contentElm}
            {...(!!offerList ? { offerList } : {})}
            background={contentElm.background}
          />
        </Suspense>);
    }

    return [<div key={contentElm.id}>Component {contentElm.type} not found!</div>, null];
  }

  getErrorPage() {
    return (
      <ErrorPage
        key="error"
        title="Kein Inhalt verfügbar"
        details="Für diese Seite wurde kein Inhalt hinterlegt."
      />
    );
  }

  render() {
    const { content: propsContent, dealer, status, background } = this.props;

    if (!propsContent) {
      return this.getErrorPage();
    }

    const [content, hasForm] = this.prepareContent(
      propsContent.filter((contentElement) => !contentElement.hidden),
      dealer.id
    );

    if (!content.length) {
      if (status === 410) {
        return <Redirect to="/" />;
      }
      return this.getErrorPage();
    }

    const components = [];

    for (let i = 0; i < content.length; i++) {
      if (background) {
        content[i].background = background;
      }
      const component = this.renderContentElement(content[i], i, hasForm);
      components.push(component);
    }

    return (
      <Fragment>
        {components.map((item, index) => (
          <Fragment key={index}>{item}</Fragment>
        ))}
      </Fragment>
    );
  }
}
